/**
 *  给一个页面元素添加水印背景
 * @param text 文字内容
 * @param textColor 文字颜色
 * @param backgroundColor 背景色
 * @param sourceBody 挂载元素
 */
function setWatermark({ text, textColor, backgroundColor, width }, sourceBody) {
  // console.log(,,'xsadaee')
  let can = document.createElement('canvas')
  can.width = width || sourceBody.clientWidth/3
  can.height = 50

  let cans = can.getContext('2d')
  cans.rotate(-20 * Math.PI / 180)
  cans.font = '14px Vedana'

  cans.fillStyle = textColor
  cans.textAlign = 'left'
  cans.textBaseline = 'Middle'
  cans.fillText(text, 0, can.height)
  sourceBody.style.background = 'url(' + can.toDataURL('image/png') + ') left top repeat'
  sourceBody.style.backgroundColor = backgroundColor
  // sourceBody.style.backgroundSize = '30% 35px'
}


export default setWatermark
